import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ProgressReportsLazy = React.lazy(
	() => import(/* webpackChunkName : 'ProgressReports' */ './components')
);

export default (store) => {
	return {
		path: 'progress-reports/:campusId?',
		element: <AsyncLoading component={<ProgressReportsLazy />} />,
		children: [],
	};
};
